import React, { useLayoutEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Outlet } from "react-router-dom";
import { fetchUserProfileThunk } from "../../Views/SettingsModule/services/profileReducer";
import TokenPersistenceManager from "../../../services/tokenPersistenceManager";
import { SET_TOKEN } from "../../Views/AuthModule/services/authReducer";
import GlobalLoader from "../../Common/GlobalLoader";
import { REMOVE_PROFILE } from "../../Views/SettingsModule/services/profileReducer";

export default function PersistLogin() {
  const dispatch = useDispatch();
  const [ready, setReady] = useState(false);
  console.log("persist login called");

  useLayoutEffect(() => {
    const token = TokenPersistenceManager.getToken();
    if (!token) return setReady(true);

    dispatch(SET_TOKEN({ token }));
    let isSubscribed = true; // Add flag to track component mount state

    dispatch(fetchUserProfileThunk())
      .unwrap()
      .catch(error => {
        if (isSubscribed) {
          // Only proceed if component is still mounted
          TokenPersistenceManager.removeToken();
          dispatch(REMOVE_PROFILE());
        }
      })
      .finally(() => {
        if (isSubscribed) {
          // Only proceed if component is still mounted
          setReady(true);
        }
      });

    return () => {
      isSubscribed = false; // Cleanup by setting flag to false
    };
  }, []);

  return ready ? <Outlet /> : <GlobalLoader />;
}
